export default function Contents() {
  return (
    <section id="contents" className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-16">
          <div className="inline-block px-5 py-2 bg-teal-50 border border-teal-200 rounded-full mb-4">
            <span className="text-teal-600 text-xs md:text-sm font-bold uppercase tracking-wider">Product Components</span>
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-gray-900 mb-4 md:mb-6">
            제품 구성
          </h2>
          <p className="text-sm md:text-lg text-gray-600 max-w-3xl mx-auto font-medium leading-relaxed">
            혁신적인 기술과 실용적인 디자인이 결합된 우리의 제품을 만나보세요
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 md:gap-8">
          <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl shadow-lg overflow-hidden border border-gray-100">
            <div className="h-64 md:h-96">
              <img
                src="https://public.readdy.ai/ai/img_res/7ee426d1a4a86fadeda045b679aea333.jpg"
                alt="발전량 계량기"
                title="로보에셋그리드 발전량 계량기"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="p-5 md:p-8">
              <h3 className="text-xl md:text-2xl font-black text-gray-900 mb-3 md:mb-4">
                발전량 계량기
              </h3>
              <p className="text-sm md:text-base text-gray-600 mb-4 md:mb-6 leading-relaxed font-medium">
                실시간으로 발전량을 측정하고 모니터링할 수 있는 스마트 계량기입니다. 
                정확한 데이터 수집과 분석을 통해 효율적인 에너지 관리를 지원합니다.
              </p>
              <ul className="space-y-2 md:space-y-3">
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-500 text-lg md:text-xl mr-2 md:mr-3 mt-0.5"></i>
                  <span className="text-sm md:text-base text-gray-700 font-medium">실시간 발전량 측정 및 표시</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-500 text-lg md:text-xl mr-2 md:mr-3 mt-0.5"></i>
                  <span className="text-sm md:text-base text-gray-700 font-medium">누적 발전량 데이터 저장</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-500 text-lg md:text-xl mr-2 md:mr-3 mt-0.5"></i>
                  <span className="text-sm md:text-base text-gray-700 font-medium">고정밀 센서 기술 적용</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-500 text-lg md:text-xl mr-2 md:mr-3 mt-0.5"></i>
                  <span className="text-sm md:text-base text-gray-700 font-medium">간편한 설치 및 유지보수</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl shadow-lg overflow-hidden border border-gray-100">
            <div className="h-64 md:h-96">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20white%20smart%20home%20energy%20monitoring%20display%20panel%20with%20touchscreen%20interface%2C%20showing%20real%20time%20power%20consumption%20graphs%20and%20data%2C%20wall%20mounted%2C%20sleek%20minimalist%20design%2C%20LED%20screen%2C%20professional%20product%20photography%2C%20soft%20lighting%2C%20high%20tech%20appearance%2C%20simple%20background%2C%20studio%20shot%2C%20modern%20home%20interior%2C%20energy%20management%20system%2C%20clean%20aesthetic%2C%20front%20view&width=600&height=400&seq=contents-display-1&orientation=landscape"
                alt="표시장치"
                title="로보에셋그리드 표시장치"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="p-5 md:p-8">
              <h3 className="text-xl md:text-2xl font-black text-gray-900 mb-3 md:mb-4">
                표시장치
              </h3>
              <p className="text-sm md:text-base text-gray-600 mb-4 md:mb-6 leading-relaxed font-medium">
                직관적인 인터페이스로 발전 현황을 한눈에 확인할 수 있는 디스플레이 장치입니다. 
                사용자 친화적인 디자인으로 누구나 쉽게 정보를 확인할 수 있습니다.
              </p>
              <ul className="space-y-2 md:space-y-3">
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-500 text-lg md:text-xl mr-2 md:mr-3 mt-0.5"></i>
                  <span className="text-sm md:text-base text-gray-700 font-medium">고해상도 디스플레이</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-500 text-lg md:text-xl mr-2 md:mr-3 mt-0.5"></i>
                  <span className="text-sm md:text-base text-gray-700 font-medium">직관적인 사용자 인터페이스</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-500 text-lg md:text-xl mr-2 md:mr-3 mt-0.5"></i>
                  <span className="text-sm md:text-base text-gray-700 font-medium">다양한 데이터 시각화</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-500 text-lg md:text-xl mr-2 md:mr-3 mt-0.5"></i>
                  <span className="text-sm md:text-base text-gray-700 font-medium">원격 모니터링 지원</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}